<template>
  <div>
    <v-snackbar top v-model="snackModel" :color="colour" rounded="pill" timeout="5000">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="getThemeColor" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["model", "text", "colour"],
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  watch:{
    model(){
      this.snackModel = this.model
    }
  },
  mounted() {
    this.snackModel = this.model
  },
 
  data() {
    return {
      snackModel:null
    }
  },
};
</script>

<style>
</style>